import { LogLevel } from "@/data/model/Enums";


export const isBeta = location.href.indexOf("tastier-beta.ch") !== -1;

export const firConfig = {
    apiKey: "AIzaSyAqImVB-eGNufbP1ZlTNFLHJ7yUw_5EOX8",
    authDomain: "tastier-e992b.firebaseapp.com",
    projectId: "tastier-e992b",
    storageBucket: "tastier-e992b.appspot.com",
    messagingSenderId: "730354122277",
    appId: isBeta ? "1:730354122277:web:289ea3fd642aa0c5abc9cc" : "1:730354122277:web:129b027b89d6f6eaabc9cc",
};

export const config = {
    cacheExpireDays: 17,
    isMockClient: false,
    mockClientAppSocketAddress: "http://socket/app",
    mockClientOperatorSocketAddress: "http://socket/operator",
    stripePublicKey: isBeta ? "pk_test_gdWtFamITrpeyTpKDwsG34IT00vkgJ2I63" : "pk_live_2QVHNXDrXgk7zUqnIxgq3Q1i",
    preventPaymentProvider: location.href.indexOf("tastier.test") !== -1,
    stripeUrl: isBeta ? "https://dashboard.stripe.com/test/" : "https://dashboard.stripe.com/",
    walleeUrlOld: isBeta ? "https://app-wallee.com/s/18475/" : "https://app-wallee.com/s/16426/",
    walleeTastierSpaceId: isBeta ? "18475" : "16426",
    walleeUrl: "https://app-wallee.com/s/",
    postFinanceUrl: "https://checkout.postfinance.ch/s/",
    waleeCardPaymentMethodId: isBeta ? "57534" : "51094",
    walleeTwintPaymentMethodId: isBeta ? "57536" : "51095",
    stripeCardPaymentMethodId: isBeta ? "stripecard" : "stripecard",
    tokenCookieName: "bearer",
    sessionIdCookieName: "sessionId",
    deviceHashCookieName: "deviceHash",
    appSessionCookieName: "tastiersession",
    buildNumber: "2d4c4e96",
    payLaterPaymentMethod: "PayLater",
    discountsPaymentMethod: "Voucher",
    applePayPaymentMethod: "ApplePay",
    googlePayPaymentMethod: "GooglePay",
    stripeCheckoutPaymentMethod: "StripeCheckout",
    appModeCookieName: "tastierappmode",
    kioskCodeCookieName: "tastierkioskcode",
};

console.log("Build number: " + config.buildNumber);

export const exceptionTypes = {
    billDoesNotExistException: "bill_does_not_exist_exception",
    billInvalidSelectionException: "bill_invalid_selection_exception",
    billIsEmptyException: "bill_is_empty_exception",
    billNoSelectedItemsException: "bill_no_selected_items_exception",
    billPaymentsInProgressException: "bill_payments_in_progress_exception",
    billDoesNotAcceptDiscountsAfterFirstPaymentException:
        "bill_does_not_accept_discounts_after_first_payment_exception",
    billTotalDiscountMismatchException: "bill_total_discount_mismatch_exception",
    cartIsEmptyException: "cart_is_empty_exception",
    cartIsOutdatedException: "cart_is_outdated_exception",
    cartTotalDiscountMismatchException: "cart_total_discount_mismatch_exception",
    covid_encryption_exception: "covid_encryption_exception",
    deviceNotFoundException: "device_not_found_exception",
    emailInUseException: "email_in_use_exception",
    emailNotConfirmedException: "email_not_confirmed_exception",
    featureNotImplementedException: "feature_not_implemented_exception",
    identityNotSignedUpException: "identity_not_signed_up_exception",
    invalidReportDateRangeException: "invalid_report_date_range_exception",
    locationSuspendedException: "location_suspended_exception",
    needAdditionalInfoForAllocationException: "need_additional_info_for_allocation_exception",
    needTableForAllocationException: "need_table_for_allocation_exception",
    newFulfillmentDateTimeAvailableException: "new_fulfillment_date_time_available_exception",
    newFulfillmentTimeAvailableException: "new_fulfillment_time_available_exception",
    noFulfillmentSlotsAvailableException: "no_fulfillment_slots_available_exception",
    noProductionSiteForRoomEnabledException: "no_production_site_for_room_enabled_exception",
    offerExpiredException: "offer_expired_exception",
    orderIsClosedException: "order_is_closed_exception",
    outdatedApiVersionException: "outdated_api_version_exception",
    outOfStockException: "out_of_stock_exception",
    overpayException: "overpay_exception",
    paymentFailedException: "payment_failed_exception",
    paymentInProgressException: "payment_in_progress_exception",
    paymentOutcomeUnknownException: "payment_outcome_unknown_exception",
    worldlinePaymentOutcomeUnknownException: "worldline_payment_outcome_unknown_exception",
    approvedPaymentNotAcceptedException: "approved_payment_not_accepted_exception",
    roomIsDeactivatedException: "room_is_deactivated_exception",
    selectedFulfillmentSlotNotAvailableException: "selected_fulfillment_slot_not_available_exception",
    stripeException: "stripe_exception",
    tableIsDeactivatedException: "table_is_deactivated_exception",
    tableNumberDoesNotExistException: "table_number_does_not_exist_exception",
    unauthorizedException: "unauthorized_exception",
    userNotAtTableException: "user_not_at_table_exception",
    walleePaymentMethodNotAvailableException: "wallee_payment_method_not_available_exception",
    worldlineTerminalNotConnectedException: "worldline_terminal_not_connected_exception",
    worldlinePaymentCancelledOnTerminalException: "worldline_payment_cancelled_on_terminal_exception",
    locationHasOrdersOrPaymentsException: "location_has_orders_or_payments_exception",
    articleActivationInsufficientStockException: "article_activation_insufficient_stock_exception",
    voucherWithCodeNotExistsException: "voucher_with_code_not_exists_exception",
    voucherNotEnabledException: "voucher_not_enabled_exception",
    voucherUsedException: "voucher_used_exception",
    voucherNotApplicableException: "voucher_not_applicable_exception",
    voucherExpiredException: "voucher_expired_exception",
    voucherAlreadyUsedException: "voucher_already_used_exception",
    discountExpiredException: "discount_expired_exception",
    voucherCodeAlreadyAppliedToCartException: "voucher_code_already_applied_to_cart_exception",
    vouchersAppliedToCartException: "vouchers_applied_to_cart_exception",
    vouchersAppliedToBillException: "vouchers_applied_to_bill_exception",
    voucherCodeAlreadyAppliedToBillException: "voucher_code_already_applied_to_bill_exception",
    invalidOrderExcelDateRangeForOrderRoleException: "invalid_order_excel_date_range_for_order_exception",
    cancellationNotAllowedForPayment: "cancellation_not_allowed_for_payment",
    singleCancellationFailedException: "single_cancellation_failed_exception",
    multipleCancellationsFailedException: "multiple_cancellations_failed_exception",
    refundOutcomeUnknownException: "refund_outcome_unknown_exception",
    multiplePdPaymentCancellationsNotSupportedException: "multiple_pd_payment_cancellations_not_supported_exception",
    twintOnlineRefundNotSupportedException: "twint_online_refund_not_supported_exception",
    payTecConnectFailedException: "pay_tec_connect_failed_exception",
    openPriceIsMissingForArticleToCartException: "open_price_is_missing_for_article_to_cart_exception",
    discountNotApplicableException: "discount_not_applicable_exception",
    discountWithCodeNotExistsException: "discount_with_code_not_exists_exception",
    discountCodeAlreadyAppliedToCartException: "discount_code_already_applied_to_cart_exception",
    discountCodeAlreadyAppliedToBillException: "discount_code_already_applied_to_bill_exception",
    discountCustomCodeAlreadyTakenException: "discount_custom_code_already_taken_exception",
    discountCustomCodeInvalidLengthException: "discount_custom_code_invalid_length_exception",
    discountCustomCodeInvalidFormatException: "discount_custom_code_invalid_format_exception",
    internalNameOfAllChildLocationsMustBeUniqueException:
        "internal_name_of_all_child_locations_must_be_unique_exception",
    internalNameAlreadyInUseByAnotherLocation: "internal_name_already_in_use_by_another_location_exception",
    linkedLocationCircularRelationException: "linked_location_circular_relation_exception",
    articleCannotBeAddedToCartException: "article_cannot_be_added_to_cart_exception",
    timerIsAlreadyRunningException: "timer_is_already_running_exception",
    pricePerMinuteArticleCannotBeOrderedException: "price_per_minute_article_cannot_be_ordered_exception",
    articleCannotBeOpenPriceAndPricePerMinuteException: "article_cannot_be_open_price_and_price_per_minute_exception",
    unauthorizedAccessToNonPortalReportException: "unauthorized_access_to_non_portal_report_exception",
    requiredContactDataIsMissingException: "required_contact_data_is_missing_exception",
    endUserNotSignedUpException: "end_user_not_signed_up_exception",
    endUserEmailNotConfirmedException: "end_user_email_not_confirmed_exception",
    vouchersMustCoverWholePayLaterOrderException: "vouchers_must_cover_whole_pay_later_order_exception",
    discountsMustCoverWholePayLaterOrderException: "discounts_must_cover_whole_pay_later_order_exception",
    tableCombinationInUseException: "table_combination_in_use_exception",
    imageLargerThanAllowedException: "image_larger_than_allowed_exception",
    billInTransferModeException: "bill_in_transfer_mode_exception",
    nothingToDiscountException: "nothing_to_discount_exception",
    tableReservationNoAvailabilityException: "table_reservation_no_availability_exception",
    moreThanOneReservationInCartException: "more_than_one_reservation_in_cart_exception",
    missingStandardServiceDurationForSeatsException: "missing_standard_service_duration_for_seats_exception",
    preorderRoomsWithoutPlanningException: "preorder_rooms_without_planning_exception",
    deliveryAddressNotInScopeOfAnyDeliveryAreaException: "delivery_address_not_in_scope_of_any_delivery_area_exception",
    deliveryAddressIsMissingException: "delivery_address_is_missing_exception",
    orderConsumptionLowerThanDeliveryMinimumOrderSize: "order_consumption_lower_than_delivery_minimum_order_size_exception",
    totalUnitsPerOrderLowerThanMinimumException: "total_units_per_order_lower_than_minimum_exception",
    totalUnitsPerOrderGreaterThanMaximumException: "total_units_per_order_greater_than_maximum_exception",
    minimumTotalUnitsPerOrderGreaterThanMaximumException: "minimum_total_units_per_order_greater_than_maximum_exception",
    minimumTotalUnitsPerOrderInvalidException: "minimum_total_units_per_order_invalid_exception",
    maximumTotalUnitsPerOrderInvalidException: "maximum_total_units_per_order_invalid_exception",
    atLeastOneDeliveryAreaRequiredException: "at_least_one_delivery_area_required_exception",
    standardAttributeCannotBeDeletedException: "standard_attribute_cannot_be_deleted_exception",
    attributeCannotBeDisplayedAsFilterException: "attribute_cannot_be_displayed_as_filter_exception",
    fulfillmentGroupCannotBeRemovedException: "fulfillment_group_cannot_be_removed_exception",
    productionSiteUsedAsBackupException: "production_site_used_as_backup_exception",
    identicalEntryFoundException: "identical_entry_found_exception",
};

export const claimTypes = {
    locationGrant: "http://tastier.ch/claims/locationgrant",
    operatorReportGrant: "http://tastier.ch/claims/operatorreportgrant",
    operatorCancellationGrant: "http://tastier.ch/claims/operatorcancellationgrant",
    operatorTransferGrant: "http://tastier.ch/claims/operatortransfergrant",
    operatorItemAvailabilityAndStockLevelGrant: "http://tastier.ch/claims/operator-item-availability-and-stock-level-grant",
};

export const exceptionReasons = {
    articlePriceChanged: "article_price_changed",
    articleNotAvailable: "article_not_available",
};

// standard attributes with frontend logic of their own, the ids are fixed by the rows that insert them and match
// StandardAttributeConstants on the server
export const standardAttributeIds = {
    orderedBefore: "f15038db-b7a7-4438-81e8-49f574bbf88e",
};

export const role = {
    Admin: "Admin",
    Manager: "Manager",
    ReportViewer: "ReportViewer",
    Pay: "Pay",
    PosIntegration: "PosIntegration",
    Operator: "Operator",
    Marketing: "Marketing",
    Order: "Order",
    Offer: "Offer",
};

export const loggingConfig = {
    enableSocketNotificationsLogging: true,
    enableApiCallsLogging: true,
    minLogLevelToSend: LogLevel.Error,
    logSessionId: true,
};

export let isTestProject = false;
export function setIsTestProject(isTest: boolean) {
    isTestProject = isTest;
}

// export const isDiscountsDebugMode = ref(false);
// (window as any).isDiscountsDebugMode = isDiscountsDebugMode;
